var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollapseLatest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.028 30.839a4.997 4.997 0 0 1-4.99-4.99l.088-5.08-5.049.089c-2.781 0-5.02-2.24-5.02-4.99 0-2.752 2.239-4.991 4.99-4.991l5.079-.09-.088-4.871c0-2.781 2.239-5.02 4.99-5.02 2.752 0 4.991 2.239 4.991 4.99l.091 4.9 4.93.09c2.721 0 4.96 2.24 4.96 4.991 0 2.752-2.239 4.99-4.99 4.99l-4.9-.087-.091 5.108c0 2.722-2.24 4.961-4.99 4.961zm-1.663-13.308v8.347c0 .887.747 1.634 1.663 1.634.917 0 1.664-.747 1.664-1.663V17.53h8.348c.886 0 1.633-.747 1.633-1.664 0-.916-.747-1.663-1.663-1.663h-8.318V5.886c0-.946-.747-1.663-1.664-1.663-.916 0-1.663.746-1.663 1.663v8.318H5.047c-.946 0-1.663.747-1.663 1.663 0 .917.747 1.664 1.663 1.664h8.318z",
    fill: "#004FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapseLatest);
export default __webpack_public_path__ + "static/media/icon-collapse_latest.f833da7d19de536618848bb456a6d408.svg";
export { ForwardRef as ReactComponent };